export const corpus = {
  "笑傲江湖": [
    {
      "key": "a828a77b",
      "source": "笑傲江湖",
      "quote": [
        "只要有人的地方就有恩怨，有恩怨就会有江湖，人就是江湖。"
      ]
    },
    {
      "key": "ec45ca93",
      "source": "笑傲江湖",
      "quote": [
        "是非只因强出口，烦恼只为强出头。"
      ]
    },
    {
      "key": "307aae7a",
      "source": "笑傲江湖",
      "quote": [
        "宁愿把世间千万种苦难都放到自己身上，只是要他平安喜乐。"
      ]
    },
    {
      "key": "da1f17b1",
      "source": "笑傲江湖",
      "quote": [
        "世上哪有十全十美之事。",
        "一个人千辛万苦的去寻求一件物事，等得到了手，也不过如此，而本来拿在手中的物事，却反而抛掉了。"
      ]
    },
    {
      "key": "80531ac6",
      "source": "笑傲江湖",
      "quote": [
        "最上品的酒，隔几年加一次新酒融合进来，终于口感醇厚而不失新鲜，品味成熟而不糜烂。"
      ]
    }
  ],
  "倚天屠龙记": [
    {
      "key": "5b37983c",
      "source": "倚天屠龙记",
      "quote": [
        "真正的人，真正的事，往往不及心中所想的那么好。"
      ]
    },
    {
      "key": "5763fc43",
      "source": "倚天屠龙记",
      "quote": [
        "他强任他强，清风拂山岗，他横由他横，明月照大江。"
      ]
    },
    {
      "key": "2f545d75",
      "source": "倚天屠龙记",
      "quote": [
        "夫千里之远，不足以举起大；千仞之高，不足以极其深。"
      ]
    },
    {
      "key": "c107a35e",
      "source": "倚天屠龙记",
      "quote": [
        "小昭又道：“我命人送各位回归中土，咱们就此别过。",
        "小昭身在波斯，日日祝公子福体康宁，诸事顺遂。”说着声音又哽咽了。",
        "张无忌道：“你身居虎狼之域，一切小心。”小昭点了点头，吩咐下属备船。",
        "谢逊、殷离、赵敏、周芷若等等一一过船。",
        "小昭将屠龙刀和倚天剑都交了给张无忌，凄然一笑，举手作别。",
        "张无忌不知说甚么话好，呆立片刻，跃入对船。",
        "只听得小昭所乘的大舰上号角声呜呜响起，两船一齐扬帆，渐离渐远。",
        "但见小昭悄立船头，怔怔向张无忌的座船望着。",
        "两人之间的海面越拉越广，终于小昭的座舰成为一个黑点，终于海上一片漆黑，长风掠帆，犹带呜咽之声。"
      ]
    },
    {
      "key": "e788c4c6",
      "source": "倚天屠龙记",
      "quote": [
        "郭襄见杨过此次到来，只与自己说得一句话，微笑相对片刻，随即分手，心中说不出的惆怅，眼见姊姊兴高采烈的站在姊夫身畔，与道贺的群雄应酬，但觉心中伤痛再难忍受，当即转身，要回自己家去。",
        "只走得几步，黄蓉已追到她身边，携住了她手，柔声道：“襄儿，怎么啦？今天不快活么？”郭襄道：“不，我快活得很。”说了这句话，随即低头，满眶泪水，险些便掉了下来。",
        "黄蓉如何不明白女儿的心事，却只说些戏文中的有趣故事，要引她破涕为笑。"
      ]
    },
    {
      "key": "8abc8c61",
      "source": "倚天屠龙记",
      "quote": [
        "其时明月在天，清风吹叶，树巅乌鸦呀啊而鸣，郭襄再也忍耐不住，泪珠夺眶而出。",
        "正是：“秋风清，秋风明；落叶聚还散，寒鸦栖复惊。",
        "相思相见知何日，此时此夜难为情。"
      ]
    }
  ],
  "鹿鼎记": [
    {
      "key": "35c1d38b",
      "source": "鹿鼎记",
      "quote": [
        "做人要能瞎蒙，就瞎蒙，生活尽量放轻松。"
      ]
    },
    {
      "key": "4bd0f1aa",
      "source": "鹿鼎记",
      "quote": [
        "书到用时方恨少，肉到肥时方恨多。"
      ]
    }
  ],
  "神雕侠侣": [
    {
      "key": "2ca5ab8f",
      "source": "神雕侠侣",
      "quote": [
        "情之为物，本是如此，入口甘甜，回味苦涩，而且遍身是刺，你就算小心万分，也不免为其所伤。"
      ]
    },
    {
      "key": "5ec0e911",
      "source": "神雕侠侣",
      "quote": [
        "一座山，隔不了两两​​相思，一天涯，断不了两两无言，且听风吟，吟不完我一生思念。"
      ]
    },
    {
      "key": "36491229",
      "source": "神雕侠侣",
      "quote": [
        "你瞧这些白云聚了又散，散了又聚，人生离合，亦复如斯。"
      ]
    },
    {
      "key": "4084ecf3",
      "source": "神雕侠侣",
      "quote": [
        "惊世骇俗的爱情总是要付出许多代价。"
      ]
    },
    {
      "key": "b5a476a3",
      "source": "神雕侠侣",
      "quote": [
        "世事遇合变幻，穷通成败，虽有关机缘气运，自有幸与不幸之别，但归根结底，总是由各人本来性格而定。"
      ]
    },
    {
      "key": "fc09176f",
      "source": "神雕侠侣",
      "quote": [
        "只有真正深情之人，那些天生具有至性至情之人，这样的两个男女碰在一起，互相爱上了，他们才会真正的爱惜对方，远胜于爱惜自己。"
      ]
    },
    {
      "key": "c82211fd",
      "source": "神雕侠侣",
      "quote": [
        "樊一翁见杨过折柳枝作兵刃，宛似小儿戏耍，显是全不将自己放在眼里，怒气更盛，他那知这柳枝柔中带韧，用以施展打狗棒法，虽不及丐帮世代相传的竹棒，其厉害处实不下于宝剑宝刀。"
      ]
    },
    {
      "key": "9580114d",
      "source": "神雕侠侣",
      "quote": [
        "马光佐道：“杨兄弟，你用我这柄刀罢！”说着刷的一声，抽刀出鞘，精光四射，确是一柄利刃。",
        "杨过双手一拱，笑道：“多谢了！这位矮老兄人是不坏的，只可惜他拜错了师父，武艺很差，一根柳条儿已够他受的。”柳枝抖动，往钢杖上搭去。"
      ]
    },
    {
      "key": "64376fe5",
      "source": "神雕侠侣",
      "quote": [
        "樊一翁听他言语中又辱及师尊，心想此番交手，实决生死存亡，再无容情，呼呼声响，展开了九九八十一路泼水杖法。",
        "杖法号称“泼水”，乃是泼水不进之意，可见其严谨紧密。"
      ]
    },
    {
      "key": "62cce3e6",
      "source": "神雕侠侣",
      "quote": [
        "杖法展开，初时响声凌厉，但数招之后，渐感挥出去方位微偏，杖头有点儿歪斜，带动的风声也略见减弱。",
        "原来杨过使开打狗棒法中的“缠”字诀，柳枝搭在杖头之上，对方钢杖到东，柳枝跟到东，钢杖上挑，柳枝也跟了上去，但总是在他劲力的横侧方向稍加推拉，使杖头不由自主的变向。",
        "这打狗棒法的“缠”字一诀，正是从武学中上乘功夫“四两拨千斤”中生发出来，精微奥妙，远胜于一般“借力打力”、“顺水推舟”之法。"
      ]
    },
    {
      "key": "962f87e5",
      "source": "神雕侠侣",
      "quote": [
        "众人愈看愈奇，万料不到杨过年纪轻轻，竟有如此神妙武功。",
        "但见樊一翁钢杖上的力道逐步减弱，杨过柳枝的劲道却是不住加强。"
      ]
    },
    {
      "key": "481df045",
      "source": "神雕侠侣",
      "quote": [
        "此消彼长，三十招后，樊一翁全身已为柳条所制，手上劲力出得愈大，愈是颠颠倒倒，难以自已，到后来宛如入了一个极强的旋风涡中，只卷得他昏头晕脑，不明所向。",
        "公孙谷主伸手在石桌上一拍，叫道：“一翁，退下！”"
      ]
    },
    {
      "key": "683696ed",
      "source": "神雕侠侣",
      "quote": [
        "这一声石破天惊，连杨过也是心头一凛，暗想：“此时岂能再让他退出。”手臂抖处，已变为“转”字诀，身子凝立不动，手腕急画小圈，带得樊一翁如陀螺般急速旋转。",
        "杨过手腕抖得愈快，樊一翁转得也是愈快，手中钢杖就如陀螺的长柄，也是跟着滴溜溜的旋转。",
        "杨过朗声说道：“你能立定脚跟不倒，算你是英雄好汉。"
      ]
    },
    {
      "key": "bed63df0",
      "source": "神雕侠侣",
      "quote": [
        "就只怕你师父差劲，教的出来徒儿上阵要摔交。”柳枝向上疾甩，跃后丈许。"
      ]
    },
    {
      "key": "f77759d5",
      "source": "神雕侠侣",
      "quote": [
        "樊一翁此时心神身子已全然不由自主，眼见他脚步踉跄，再转得几转，立即就要摔倒。",
        "公孙谷主斗然跃高，身在半空，举掌在钢杖头上一拍，轻轻纵回。",
        "这一拍看上去轻描淡写，力道却是奇大，将钢杖拍得深入地下二尺有余，登时便不转了。"
      ]
    },
    {
      "key": "6018c7e8",
      "source": "神雕侠侣",
      "quote": [
        "樊一翁双手牢牢抓住钢杖，这才不致摔倒，但身子东摇西摆，恍如中酒，一时之间难以宁定。"
      ]
    },
    {
      "key": "d245c14d",
      "source": "神雕侠侣",
      "quote": [
        "潇湘子、尹克西等瞧瞧杨过，又瞧瞧公孙谷主，心想这二人均非易与之辈，且看这场龙争虎斗谁胜谁败，心下均存了幸灾乐祸的隔岸观火之意。",
        "只有马光佐一意助着杨过，大声呼喝：“杨兄弟，好功夫！矮胡子输了！”"
      ]
    },
    {
      "key": "af340485",
      "source": "神雕侠侣",
      "quote": [
        "我命人送各位回归中土，咱们就此别过。",
        "小昭身在波斯，日日祝公子福体康宁，诸事顺遂。”说着声音又哽咽了。",
        "张无忌道：“你身居虎狼之域，一切小心。”小昭点了点头，吩咐下属备船。",
        "谢逊、殷离、赵敏、周芷若等等一一过船。",
        "小昭将屠龙刀和倚天剑都交了给张无忌，凄然一笑，举手作别。",
        "张无忌不知说甚么话好，呆立片刻，跃入对船。",
        "只听得小昭所乘的大舰上号角声呜呜响起，两船一齐扬帆，渐离渐远。",
        "但见小昭悄立船头，怔怔向张无忌的座船望着。",
        "两人之间的海面越拉越广，终于小昭的座舰成为一个黑点，终于海上一片漆黑，长风掠帆，犹带呜咽之声。"
      ]
    },
    {
      "key": "12b6dbd5",
      "source": "神雕侠侣",
      "quote": [
        "杨过知他素来疯疯癫癫，只怕他已然忘了自己，大叫道：“爸爸，是我啊，是你的儿子啊。”这几句话中充满了激情。",
        "欧阳锋一呆，拉着他手，将他脸庞转到月光下看去，正是数年来自己到处找寻的义儿，只是一来他身材长高，二来武艺了得，是以初时难以认出。",
        "他当即抱住杨过，木叫大嚷：“孩儿，我找得你好苦！”两人紧紧搂在一起，都流下泪来。"
      ]
    },
    {
      "key": "22db1480",
      "source": "神雕侠侣",
      "quote": [
        "她喜孜孜的回过头来，想要杨过称赞几句。",
        "一回头，只见杨过泪流满面，悲不自胜。",
        "小龙女一咬牙，只作不见，微笑道：“你说我好不好看？”杨过哽咽道：“好看极了！我给你带上凤冠！”拿起凤冠，走到她身后给她戴上。",
        "小龙女在镜中见他举袖擦干了泪水，再到身前时，脸上已作欢容，笑道：“我以后叫你娘子呢，还是仍然叫姑姑？”小龙女心想：“还说什么‘以后’啊？难道咱俩真的还有‘以后’么？”但仍是强作喜色，微笑道：“再叫姑姑自然不好。",
        "娘子夫人的，又太老气啦！” 杨过道：“你的小名儿到底叫什么？今天可以说给我听了罢。”小龙女道：“我没小名儿的，师父只叫我作龙儿。"
      ]
    },
    {
      "key": "cc10fc44",
      "source": "神雕侠侣",
      "quote": [
        "小龙女听着他这么胡扯，咬着牙齿不住微笑，终于忍耐不住，“哇”的一声，伏在箱子上哭了出来。",
        "杨过抢步上前，将她搂在怀里，柔声道：“龙儿，你不好，我也不好，咱们何必理会以后。",
        "今天你不会死的，我也不会死。",
        "咱俩今儿欢欢喜喜的，谁也不许去想明天的事。”小龙女抬起头来，含泪微笑，点了点头。"
      ]
    },
    {
      "key": "c8cacf04",
      "source": "神雕侠侣",
      "quote": [
        "那少女提起酒壶给他斟了一碗酒，笑道：“我怎会不信？快点儿讲罢！”又叫道：“店小二，再打十斤酒，切二十斤牛肉，我姊姊请众位伯伯叔叔喝酒，驱驱寒气。"
      ]
    },
    {
      "key": "93e31275",
      "source": "神雕侠侣",
      "quote": [
        "那美貌少妇沉着脸道：“我便是要请客，也不请胡说八道之人。",
        "店小二，这酒肉的钱可不能开在我的帐上。”店小二一愣，望望少妇，又望望少女，不知如何是好。",
        "那少女从头上拔下一枚金钗，递给店小二，说道：“这是真金的钗儿，值得十几两银子罢。",
        "你拿去给我换了。",
        "再打十斤酒，切二十斤羊肉。"
      ]
    },
    {
      "key": "a3ac6a85",
      "source": "神雕侠侣",
      "quote": [
        "那少妇怒道：“妹妹，你定要跟我赌气，是不是？单是钗头这颗明珠，总值百多两银子，你死赖活赖的跟朱伯伯要来，却这么随随便便的请人喝酒。",
        "瞧你回到襄阳时，妈问起来时怎么交代？”那少女伸伸舌头，笑道：“我说在道上掉了，找来找去找不到？”那少妇道：“我才不跟你圆谎呢。”那少女伸筷夹了一块牛肉，放在口中吃了。",
        "说道：“吃也吃过了，难道还能退么？各位请啊，不用客气。"
      ]
    },
    {
      "key": "568ff3bb",
      "source": "神雕侠侣",
      "quote": [
        "众人见她姊妹二人斗气，都觉有趣，心中均喜那少女天真潇洒，便是不会喝酒之人也都端起酒碗喝了几口，暗中帮那少女。",
        "那少妇赌气闭上眼睛，伸手塞住耳朵。"
      ]
    },
    {
      "key": "44bb1c21",
      "source": "神雕侠侣",
      "quote": [
        "今番良晤，豪兴不浅，他日江湖相逢，再当杯酒言欢。",
        "“咱们就此别过。”说着袍袖一拂，携着小龙女之手，与神雕并肩下山。"
      ]
    }
  ],
  "书剑恩仇录": [
    {
      "key": "b7f44409",
      "source": "书剑恩仇录",
      "quote": [
        "慧极必伤，情深不寿，强极则辱，谦谦君子，温润如玉。"
      ]
    },
    {
      "key": "08912721",
      "source": "书剑恩仇录",
      "quote": [
        "天子者，有道则人推而为主，无道则人弃而不用，诚可畏也。"
      ]
    }
  ],
  "天龙八部": [
    {
      "key": "94ec2604",
      "source": "天龙八部",
      "quote": [
        "男子汉大丈夫，第一论人品心肠，第二论才干事业，第三论文学武功。"
      ]
    },
    {
      "key": "d9c748e4",
      "source": "天龙八部",
      "quote": [
        "佛由心生，佛即是觉，旁人只能指点，却不能代劳。"
      ]
    },
    {
      "key": "a155fb05",
      "source": "天龙八部",
      "quote": [
        "明白别人容易，明白自己甚难。",
        "克敌不易，客服自己心中的贪嗔痴三毒，更是艰难无比！"
      ]
    },
    {
      "key": "b798f96b",
      "source": "天龙八部",
      "quote": [
        "我是尘间摆渡人，为君闲计百年身。"
      ]
    },
    {
      "key": "8689dec5",
      "source": "天龙八部",
      "quote": [
        "青光闪动，一柄青钢剑倏地刺出，指向在年汉子左肩，使剑少年不等招用老，腕抖剑斜，剑锋已削向那汉子右颈。",
        "那中年汉子剑挡格，铮的一声响，双剑相击，嗡嗡作声，震声未绝，双剑剑光霍霍，已拆了三招，中年汉子长剑猛地击落，直砍少年顶门。",
        "那少年避向右侧，左手剑诀一引，青钢剑疾刺那汉子大腿。"
      ]
    },
    {
      "key": "dd41e09e",
      "source": "天龙八部",
      "quote": [
        "练武厅东坐着二人。",
        "上首是个四十左右的中年道姑，铁青着脸，嘴唇紧闭。",
        "下首是个五十余岁的老者，右手捻着长须，神情甚是得意。",
        "两人的座位相距一丈有余，身后各站着二十余名男女弟子。",
        "西边一排椅子上坐着十余位宾客。",
        "东西双方的目光都集注于场中二人的角斗。"
      ]
    },
    {
      "key": "50422c44",
      "source": "天龙八部",
      "quote": [
        "眼见那少年与中年汉子已拆到七十余招，剑招越来越紧，兀自未分胜败。",
        "突然中年汉子一剑挥出，用力猛了，身子微微一幌，似欲摔跌。",
        "西边宾客中一个身穿青衫的年轻男子忍不住“嗤”的一声笑。",
        "他随即知道失态，忙伸手按住了口。"
      ]
    },
    {
      "key": "99aeea1d",
      "source": "天龙八部",
      "quote": [
        "便在这时，场中少年左手呼一掌拍出，击向那汉子后心，那汉子向前跨出一步避开，手中长剑蓦地圈转，喝一声：“着！”那少年左腿已然中剑，腿下一个踉跄，长剑在地下一撑，站直身子待欲再斗，那中年汉子已还剑入鞘，笑道：“褚师弟，承让、承让，伤得不厉害么？”那少年脸色苍白，咬着嘴唇道：“多谢龚师兄剑下留情。”"
      ]
    }
  ],
  "射雕英雄传": [
    {
      "key": "395e7d40",
      "source": "射雕英雄传",
      "quote": [
        "世上聪明人本来是有的，不过这种人你遇上了，多半非倒大霉不可。"
      ]
    },
    {
      "key": "dee67d59",
      "source": "射雕英雄传",
      "quote": [
        "教而不明其法，学而不得其道。"
      ]
    },
    {
      "key": "410f9301",
      "source": "射雕英雄传",
      "quote": [
        "凡人有生必有死，生固欣然，死亦天命。"
      ]
    }
  ],
  "雪山飞狐": [
    {
      "key": "cd449d8c",
      "source": "雪山飞狐",
      "quote": [
        "倘若情丝一斩便断，那也算不得是情丝了。"
      ]
    },
    {
      "key": "17ab898c",
      "source": "雪山飞狐",
      "quote": [
        "世上最宝贵之物，乃是两心相悦的真正情爱，决非价值连城的宝藏。"
      ]
    }
  ],
  "新笑傲江湖": [
    {
      "key": "f5153db8",
      "source": "新笑傲江湖",
      "quote": [
        "我一见到你，我就变得不像我自己。"
      ]
    }
  ],
  "侠客行": [
    {
      "key": "67c79ded",
      "source": "侠客行",
      "quote": [
        "人家心中想给你，你不用求，人家自然会给你；人家不肯的，你便苦苦哀求也是无用，反而惹得人家讨厌。"
      ]
    }
  ]
};